import { render } from "./PredictionHighlights.vue?vue&type=template&id=44904ef7&scoped=true"
import script from "./PredictionHighlights.vue?vue&type=script&lang=js"
export * from "./PredictionHighlights.vue?vue&type=script&lang=js"

import "./PredictionHighlights.vue?vue&type=style&index=0&id=44904ef7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44904ef7"]])

export default __exports__